import React from 'react';
import { Mui } from '../..';

export const Face = props => <Mui.Icon {...props}>face</Mui.Icon>;
